import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dec2422"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["viewBox"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs data-v-5dec2422><symbol id=\"square\" viewBox=\"-1.5 -1.5 3 3\" data-v-5dec2422><rect x=\"-0.886\" y=\"-0.886\" width=\"1.772\" height=\"1.772\" data-v-5dec2422></rect></symbol><symbol id=\"circle\" viewBox=\"-1.5 -1.5 3 3\" data-v-5dec2422><circle cx=\"0\" cy=\"0\" r=\"1\" data-v-5dec2422></circle></symbol><symbol id=\"triangle\" viewBox=\"-1.5 -1.5 3 3\" data-v-5dec2422><path d=\"M -1.347,0.778 1.347,0.778 0,-1.555 Z\" data-v-5dec2422></path></symbol><symbol id=\"pentagram\" viewBox=\"-1.5 -1.5 3 3\" data-v-5dec2422><path d=\"M -0.67565,0.93 0.67565,0.93 1.0932,-0.3551706841894581 0,-1.1495 -1.0932,-0.3551706841894581 Z\" data-v-5dec2422></path></symbol><symbol id=\"star\" viewBox=\"-1.5 -1.5 3 3\" data-v-5dec2422><path d=\"M 0.69236155,1.054307 0.00345969,0.69533821 -0.68279921,1.0593342 -0.55428199,0.29322216 -1.1125284,-0.24696789 l 0.76832984,-0.11451451 0.34124363,-0.6978518 0.34633676,0.69533819 0.76914657,0.1088939 -0.55428196,0.54425715 z\" data-v-5dec2422></path></symbol><radialGradient id=\"selected-gradient\" data-v-5dec2422><stop offset=\"60%\" stop-color=\"rgb(0, 80, 150)\" stop-opacity=\"0.25\" data-v-5dec2422></stop><stop offset=\"100%\" stop-color=\"rgb(0, 80, 150)\" stop-opacity=\"0\" data-v-5dec2422></stop></radialGradient><filter id=\"dilate-and-xor\" data-v-5dec2422><feMorphology in=\"SourceGraphic\" result=\"dilate-result\" operator=\"dilate\" radius=\"0.35\" data-v-5dec2422></feMorphology><feComposite in=\"SourceGraphic\" in2=\"dilate-result\" result=\"xor-result\" operator=\"xor\" data-v-5dec2422></feComposite></filter></defs>", 1)
const _hoisted_3 = {
  key: 0,
  "text-anchor": "middle",
  class: "edithint"
}
const _hoisted_4 = {
  x: "0",
  y: "-1em"
}
const _hoisted_5 = {
  x: "0",
  dy: "2em"
}
const _hoisted_6 = { id: "marksBackgroundLayer" }
const _hoisted_7 = ["cx", "cy"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["x1", "y1", "x2", "y2"]
const _hoisted_10 = ["x1", "y1", "x2", "y2", "filter"]
const _hoisted_11 = ["x", "y", "text-anchor", "dx", "dy"]
const _hoisted_12 = ["x", "y", "text-anchor", "dx", "dy"]
const _hoisted_13 = ["href", "x", "y"]
const _hoisted_14 = ["x", "y"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { class: "brushParent" }, null, -1))
const _hoisted_16 = { class: "marksForegroundLayer" }
const _hoisted_17 = ["x", "y", "onClick"]
const _hoisted_18 = ["href", "x", "y", "onClick"]
const _hoisted_19 = {
  key: 1,
  id: "position",
  x: "-110",
  y: "-110",
  width: "220",
  height: "220"
}
const _hoisted_20 = {
  x: 0,
  y: "-102",
  "text-anchor": "middle",
  class: "ego"
}
const _hoisted_21 = { id: "zoomBtns" }
const _hoisted_22 = ["title", "disabled"]
const _hoisted_23 = { class: "icon is-large" }
const _hoisted_24 = {
  id: "brushBtns",
  ref: "brushBtns"
}
const _hoisted_25 = ["title", "disabled"]
const _hoisted_26 = { class: "icon is-small" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "icon is-small" }
const _hoisted_29 = { class: "icon is-medium" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "icon is-small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkMapCoordinates = _resolveComponent("NetworkMapCoordinates")!
  const _component_NetworkMapSectors = _resolveComponent("NetworkMapSectors")!
  const _component_ComparisonSlider = _resolveComponent("ComparisonSlider")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("svg", {
      id: "nwkmap",
      viewBox: 
      _ctx.showVersionSlider && !_ctx.isEditMode
        ? '-110 -117 220 220'
        : '-106 -106 212 212'
    
    }, [
      _hoisted_2,
      _createVNode(_component_NetworkMapCoordinates, { transform: _ctx.transform }, null, 8, ["transform"]),
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("text", _hoisted_3, [
            _createElementVNode("tspan", _hoisted_4, _toDisplayString(_ctx.t("maptext")), 1),
            _createElementVNode("tspan", _hoisted_5, _toDisplayString(_ctx.t("maptext2")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("g", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alteriMarks, (mark) => {
          return (_openBlock(), _createElementBlock("g", {
            key: 'shadow' + mark.d.id
          }, [
            (mark.selected)
              ? (_openBlock(), _createElementBlock("circle", {
                  key: 0,
                  cx: mark.x,
                  cy: mark.y,
                  r: "4",
                  fill: "url('#selected-gradient')"
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.connections)
          ? (_openBlock(), _createElementBlock("g", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectionMarks, (mark, index) => {
                return (_openBlock(), _createElementBlock("line", {
                  key: 'conn' + index,
                  x1: mark.x1,
                  y1: mark.y1,
                  x2: mark.x2,
                  y2: mark.y2,
                  class: _normalizeClass({ select: mark.selected })
                }, null, 10, _hoisted_9))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alteriMarks, (mark) => {
          return (_openBlock(), _createElementBlock("g", {
            key: mark.d.id
          }, [
            (_ctx.connections && mark.d.edgeType >= 1)
              ? (_openBlock(), _createElementBlock("line", {
                  key: 0,
                  class: _normalizeClass({ select: mark.selected }),
                  x1: _ctx.egoCoords[0],
                  y1: _ctx.egoCoords[1],
                  x2: mark.x,
                  y2: mark.y,
                  filter: mark.d.edgeType == 2 ? 'url(#dilate-and-xor)' : undefined
                }, null, 10, _hoisted_10))
              : _createCommentVNode("", true),
            (_ctx.alteriNames && _ctx.useTextBG)
              ? (_openBlock(), _createElementBlock("text", {
                  key: 1,
                  style: _normalizeStyle({ 'font-size': _ctx.labelSize + 'px' }),
                  class: "textbg",
                  "vector-effect": "non-scaling-stroke",
                  x: mark.x,
                  y: mark.y,
                  "text-anchor": mark.x < 0 ? 'end' : 'start',
                  dx: mark.x < 0 ? -3 : 3,
                  dy: mark.y < 0 ? -1 : 4
                }, _toDisplayString(mark.label) + " " + _toDisplayString(_ctx.showAge && mark.d.age.length >= 1 ? "/ " + mark.d.age : "") + " " + _toDisplayString(_ctx.showRole ? " / " + _ctx.getRoleShort(mark.d.role) : ""), 13, _hoisted_11))
              : _createCommentVNode("", true),
            (_ctx.alteriNames)
              ? (_openBlock(), _createElementBlock("text", {
                  key: 2,
                  style: _normalizeStyle({ 'font-size': _ctx.labelSize + 'px' }),
                  x: mark.x,
                  y: mark.y,
                  "text-anchor": mark.x < 0 ? 'end' : 'start',
                  dx: mark.x < 0 ? -3 : 3,
                  dy: mark.y < 0 ? -1 : 4
                }, _toDisplayString(mark.label) + " " + _toDisplayString(_ctx.showAge && mark.d.age.length >= 1 ? "/ " + mark.d.age : "") + " " + _toDisplayString(_ctx.showRole ? " / " + _ctx.getRoleShort(mark.d.role) : ""), 13, _hoisted_12))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (!_ctx.emoji || !_ctx.egoEmoji)
          ? (_openBlock(), _createElementBlock("use", {
              key: 1,
              id: "ego",
              href: '#' + _ctx.egoShape,
              x: _ctx.egoCoords[0],
              y: _ctx.egoCoords[1],
              class: "mark",
              width: "4",
              height: "4",
              transform: "translate(-2,-2)"
            }, null, 8, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.emoji && _ctx.egoEmoji)
          ? (_openBlock(), _createElementBlock("text", {
              key: 2,
              x: _ctx.egoCoords[0],
              y: _ctx.egoCoords[1] + 1,
              class: "mark",
              style: {"font-size":"4px","cursor":"pointer","text-anchor":"middle"}
            }, _toDisplayString(_ctx.egoEmoji), 9, _hoisted_14))
          : _createCommentVNode("", true)
      ]),
      _hoisted_15,
      _createElementVNode("g", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alteriMarks, (mark) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (mark.d.emoji && _ctx.emoji)
              ? (_openBlock(), _createElementBlock("text", {
                  key: mark.d.id,
                  x: mark.x - 3,
                  y: mark.y + 1,
                  class: "mark clickAble",
                  onClick: _withModifiers(($event: any) => (_ctx.clickAlter(mark.d)), ["stop"]),
                  style: {"font-size":"4px","cursor":"pointer"}
                }, _toDisplayString(mark.d.emoji), 9, _hoisted_17))
              : (_openBlock(), _createElementBlock("use", {
                  key: mark.d.id,
                  href: '#' + mark.shape,
                  x: mark.x,
                  y: mark.y,
                  class: "mark clickAble",
                  width: "4",
                  height: "4",
                  transform: "translate(-2,-2)",
                  onClick: _withModifiers(($event: any) => (_ctx.clickAlter(mark.d)), ["stop"])
                }, null, 8, _hoisted_18))
          ], 64))
        }), 256))
      ]),
      _createVNode(_component_NetworkMapSectors, {
        transform: _ctx.transform,
        onZoomSector: _ctx.zoomSector
      }, null, 8, ["transform", "onZoomSector"]),
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("rect", _hoisted_19))
        : _createCommentVNode("", true),
      _createElementVNode("text", _hoisted_20, _toDisplayString(_ctx.egoLabel), 1),
      (_ctx.showVersionSlider && !_ctx.isEditMode)
        ? (_openBlock(), _createBlock(_component_ComparisonSlider, { key: 2 }))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1)),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        id: "zoomResetBtn",
        class: "button is-medium",
        type: "button",
        title: _ctx.t('zoomreset'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetZoom())),
        disabled: _ctx.isNotZoomed
      }, [
        _createElementVNode("span", _hoisted_23, [
          _createVNode(_component_font_awesome_icon, { icon: "search-minus" })
        ])
      ], 8, _hoisted_22)
    ]),
    _createElementVNode("div", _hoisted_24, [
      (!_ctx.isClusterFullyConnected)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "btnClusterConnect",
            class: "button is-small",
            type: "button",
            title: _ctx.t('clusterconnect'),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clusterConnect && _ctx.clusterConnect(...args))),
            disabled: !_ctx.isClusterConnectPossible
          }, [
            _createElementVNode("span", _hoisted_26, [
              _createVNode(_component_font_awesome_icon, { icon: "link" })
            ])
          ], 8, _hoisted_25))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            id: "btnClusterUnConnect",
            class: "button is-small",
            type: "button",
            title: _ctx.t('deconnect'),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clusterDisconnect && _ctx.clusterDisconnect(...args)))
          }, [
            _createElementVNode("span", _hoisted_28, [
              _createVNode(_component_font_awesome_icon, { icon: "unlink" })
            ])
          ], 8, _hoisted_27)),
      _createElementVNode("button", {
        id: "zoomBtn",
        class: "button is-small",
        type: "button",
        title: "Zoom",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.zoomBrushedArea && _ctx.zoomBrushedArea(...args)))
      }, [
        _createElementVNode("span", _hoisted_29, [
          _createVNode(_component_font_awesome_icon, { icon: "search-plus" })
        ])
      ]),
      _createElementVNode("button", {
        class: "button is-small",
        type: "button",
        title: _ctx.t('closebrush'),
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearBrush && _ctx.clearBrush(...args)))
      }, [
        _createElementVNode("span", _hoisted_31, [
          _createVNode(_component_font_awesome_icon, { icon: "times" })
        ])
      ], 8, _hoisted_30)
    ], 512)
  ], 64))
}